/**
 * Configuración global de actions
 */
export const DO_ROUTE = "DO_ROUTE";
export const DO_IS_LOADING = "DO_IS_LOADING";
export const DO_REQUEST_API = "DO_REQUEST_API";

export const DO_LANDING = "DO_LANDING";
export const DO_LANDING_SUCCESS = "DO_LANDING_SUCCESS";
export const DO_LANDING_ERROR = "DO_LANDING_ERROR";

export const DO_PASO1 = "DO_PASO1";
export const DO_PASO2 = "DO_PASO2";
export const DO_GRACIAS = "DO_GRACIAS";
export const DO_MENSAJE = "DO_MENSAJE";
export const DO_NOTIFICATION_TOAST = "DO_NOTIFICATION_TOAST";
export const DO_NOTIFICATION_TOAST_RESET = "DO_NOTIFICATION_TOAST_RESET";
export const DO_NOTIFICATION_MODAL = "DO_NOTIFICATION_MODAL";
export const DO_NOTIFICATION_MODAL_RESET = "DO_NOTIFICATION_MODAL_RESET";
export const DO_CONSULTAR = "DO_CONSULTAR";
export const DO_SIN_PATENTE = "DO_SIN_PATENTE";
export const DO_PATENTE = "DO_PATENTE";
export const DO_CONDICION = "DO_CONDICION";
export const DO_MARCA = "DO_MARCA";
export const DO_MODELO = "DO_MODELO";
export const DO_VERSION = "DO_VERSION";
export const DO_GNC = "DO_GNC";
export const DO_RESUMEN = "DO_RESUMEN";
export const DO_FORZAR_DNE = "DO_FORZAR_DNE";
export const DO_MERLIN = "DO_MERLIN";
export const DO_LANDING_PLANES = "DO_LANDING_PLANES";

export const DO_CONSULTA_ES_CLIENTE = "DO_CONSULTA_ES_CLIENTE";
export const DO_CONSULTA_ES_CLIENTE_SUCCESS = "DO_CONSULTA_ES_CLIENTE_SUCCESS";
export const DO_CONSULTA_ES_CLIENTE_ERROR = "DO_CONSULTA_ES_CLIENTE_ERROR";

export const DO_CONSULTA_DATOS_PATENTE = "DO_CONSULTA_DATOS_PATENTE";
export const DO_CONSULTA_DATOS_PATENTE_SUCCESS =
  "DO_CONSULTA_DATOS_PATENTE_SUCCESS";
export const DO_CONSULTA_DATOS_PATENTE_ERROR =
  "DO_CONSULTA_DATOS_PATENTE_ERROR";

export const DO_CONSULTA_MARCAS = "DO_CONSULTA_MARCAS";
export const DO_CONSULTA_MARCAS_SUCCESS = "DO_CONSULTA_MARCAS_SUCCESS";
export const DO_CONSULTA_MARCAS_ERROR = "DO_CONSULTA_MARCAS_ERROR";

export const DO_CONSULTA_MODELOS = "DO_CONSULTA_MODELOS";
export const DO_CONSULTA_MODELOS_SUCCESS = "DO_CONSULTA_MODELOS_SUCCESS";
export const DO_CONSULTA_MODELOS_ERROR = "DO_CONSULTA_MODELOS_ERROR";

export const DO_CONSULTA_VERSION = "DO_CONSULTA_VERSION";
export const DO_CONSULTA_VERSION_SUCCESS = "DO_CONSULTA_VERSION_SUCCESS";
export const DO_CONSULTA_VERSION_ERROR = "DO_CONSULTA_VERSION_ERROR";

export const DO_CONSULTA_SIMULACION = "DO_CONSULTA_SIMULACION";
export const DO_CONSULTA_SIMULACION_SUCCESS = "DO_CONSULTA_SIMULACION_SUCCESS";
export const DO_CONSULTA_SIMULACION_ERROR = "DO_CONSULTA_SIMULACION_ERROR";

export const DO_CONSULTA_VIVIENDA = "DO_CONSULTA_VIVIENDA";
export const DO_CONSULTA_VIVIENDA_SUCCESS = "DO_CONSULTA_VIVIENDA_SUCCESS";
export const DO_CONSULTA_VIVIENDA_ERROR = "DO_CONSULTA_VIVIENDA_ERROR";
export const DO_RECOTIZACION_COBERTURA = "DO_RECOTIZACION_COBERTURA";
export const DO_COTIZACION_HOGAR = "DO_COTIZACION_HOGAR";
export const DO_COTIZACION_HOGAR_SUCCESS = "DO_COTIZACION_HOGAR_SUCCESS";
export const DO_COTIZACION_HOGAR_ERROR = "DO_COTIZACION_HOGAR_ERROR";
export const DO_RECOTIZACION_HOGAR = "DO_RECOTIZACION_HOGAR";
export const DO_RECOTIZACION_HOGAR_SUCCESS = "DO_RECOTIZACION_HOGAR_SUCCESS";
export const DO_RECOTIZACION_HOGAR_ERROR = "DO_RECOTIZACION_HOGAR_ERROR";
export const DO_OBTENER_PDF_HOGAR = "DO_OBTENER_PDF_HOGAR";
export const DO_OBTENER_PDF_HOGAR_SUCCESS = "DO_OBTENER_PDF_HOGAR_SUCCESS";
export const DO_OBTENER_PDF_HOGAR_ERROR = "DO_OBTENER_PDF_HOGAR_ERROR";
export const DO_GUARDAR_DESCRIPCION_VIVIENDA =
  "DO_GUARDAR_DESCRIPCION_VIVIENDA";

export const DO_COBERTURA_ANADIR = "DO_COBERTURA_ANADIR";
export const DO_COBERTURA_QUITAR = "DO_COBERTURA_QUITAR";
export const DO_COBERTURA_QUITAR_TODAS = "DO_COBERTURA_QUITAR_TODAS";
export const DO_COBERTURAS_SELECCIONADAS = "DO_COBERTURAS_SELECCIONADAS";

export const DO_NORMALIZAR_CELULAR = "DO_NORMALIZAR_CELULAR";
export const DO_QUIERO_ME_CONTACTEN = "DO_QUIERO_ME_CONTACTEN";

export const DO_POST_QUIERO_ME_CONTACTEN = "DO_POST_QUIERO_ME_CONTACTEN";
export const DO_POST_QUIERO_ME_CONTACTEN_SUCCESS =
  "DO_POST_QUIERO_ME_CONTACTEN_SUCCESS";
export const DO_POST_QUIERO_ME_CONTACTEN_ERROR =
  "DO_POST_QUIERO_ME_CONTACTEN_ERROR";
export const DO_GET_TOKEN_USER_ID = "DO_GET_TOKEN_USER_ID";
